import store from './store';

export const promoStore = store;
export * from './actions';
